import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { SessionInterface } from '../data/session.interface';
import { SessionClientInterface } from '../../client/api/session-client.interface';
import { Transaction } from '../transaction/transaction';
import { TransactionRequestInterface } from '../transaction/transaction-request.interface';

@Injectable()
export class SessionApiRepository {
    private current: SessionInterface;

    constructor(private sessionClient: SessionClientInterface, private transactionRequest: TransactionRequestInterface) {}

    load(): Observable<Transaction<SessionInterface>> {
        if (!this.current) {
            return this.transactionRequest.wrap(this.sessionClient.create().pipe(tap((session) => (this.current = session))));
        }

        return this.transactionRequest.wrap(of(this.current));
    }

    update(token: string): Observable<Transaction<void>> {
        return this.transactionRequest.wrap(
            new Observable((observer: any) => {
                this.current.token = token;

                observer.next(Transaction.success());
                observer.complete();
            })
        );
    }
}
